import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { ProfessionalService } from '../../../shared/services/professional.service';
import { OccupationAreasService } from '../../../shared/services/occupation-areas.service';
import { SpecialtiesService } from '../../../shared/services/specialties.service';
import { BankService } from '../../../shared/services/bank.service';
import { AddressService } from '../../../shared/services/address.service';
import { ModalFileComponent } from './modal-file/modal-file.component';
import { FileService } from '../../../shared/services/file.service';
import { ModalPdfViewerComponent } from '../../../shared/components/modal-pdf-viewer/modal-pdf-viewer.component';
import { RejectDocumentModalComponent } from './reject-document-modal/reject-document-modal.component';

@Component({
  selector: 'app-edit-professional',
  templateUrl: './edit-professional.component.html',
  styleUrls: ['./edit-professional.component.scss'],
})
export class EditProfessionalComponent implements OnInit {
  private professionalId: string;

  name: string;

  employmentTypeOptions = [
    { value: 'service_provider', label: 'Prestador de Serviço' },
    { value: 'partner', label: 'Sócio' },
    { value: 'employee', label: 'CLT' },
  ];

  statusOptions = [
    { value: 'APPROVED', label: 'Aprovado' },
    { value: 'PENDING', label: 'Pendente' },
    { value: 'REJECTED', label: 'Rejeitado' },
  ];

  nationalities: any[] = [
    'Brasileiro',
    'Portuguesa',
    'Filipina',
    'Sul-Africano',
    'Zimbabweano',
    'Namibiana',
    'Boliviano',
    'Chileno',
    'Colombiano',
    'Costarriquenho',
    'Cubano',
    'Dominicano',
    'Equatoriano',
    'Salvadorenho',
    'Granadino',
    'Guatemalteco',
    'Guianês',
    'Guianense',
    'Haitiano',
    'Hondurenho',
    'Jamaicano',
    'Mexicano',
    'Nicaraguense',
    'Panamenho',
    'Paraguaio',
    'Peruano',
    'Portorriquenho',
    'Dominicana',
    'São-cristovense',
    'São-vicentino',
    'Santa-lucense',
    'Surinamês',
    'Trindadense',
    'Uruguaio',
    'Venezuelano',
    'Alemã',
    'Austríac',
    'Belga',
    'Croata',
    'Dinamarquês',
    'Antiguano',
    'Argentino',
    'Bahamense',
    'barbadense',
    'Belizenho',
    'Eslovaco',
    'Esloveno',
    'Espanhol',
    'Francês',
    'Grego',
    'Húngaro',
    'Irlandês',
    'Italiano',
    'Noruego',
    'Holandês',
    'Polonês',
    'Inglês',
    'Galês',
    'Escocês',
    'Romeno',
    'Russo',
    'Sérvio',
    'Sueco',
    'Suíço',
    'Turco',
    'Ucraniano',
    'Americano',
    'Canadense',
    'Angolano',
    'Moçambicano',
    'Sul-africano',
    'Zimbabuense',
    'Argélia',
    'Comorense',
    'Egípcio',
    'Líbio',
    'Marroquino',
    'Ganés',
    'Queniano',
    'Ruandês',
    'Ugandense',
    'Bechuano',
    'Marfinense',
    'Camaronense',
    'Nigeriano',
    'Somali',
    'Australiano',
    'Neozelandês',
    'Afegão',
    'Saudita',
    'Armeno',
    'Bangladesh',
    'Chinês',
    'Norte-coreano',
    'Sul-coreano',
    'Indiano',
    'Indonésio',
    'Iraquiano',
    'Iraniano',
    'Israelita',
    'Japonês',
    'Malaio',
    'Nepalês',
    'Omanense',
    'Paquistanês',
    'Palestino',
    'Qatarense',
    'Sírio',
    'Cingalês',
    'Tailandês',
    'Timorense',
    'Árabe',
    'Vietnamita',
    'Iemenita',
  ];

  states: any[] = [
    { value: 'AC', name: 'Acre' },
    { value: 'AL', name: 'Alagoas' },
    { value: 'AP', name: 'Amapá' },
    { value: 'AM', name: 'Amazonas' },
    { value: 'BA', name: 'Bahia' },
    { value: 'CE', name: 'Ceará' },
    { value: 'DF', name: 'Distrito Federal' },
    { value: 'ES', name: 'Espírito Santo' },
    { value: 'GO', name: 'Goiás' },
    { value: 'MA', name: 'Maranhão' },
    { value: 'MT', name: 'Mato Grosso' },
    { value: 'MS', name: 'Mato Grosso do Sul' },
    { value: 'MG', name: 'Minas Gerais' },
    { value: 'PA', name: 'Pará' },
    { value: 'PB', name: 'Paraíba' },
    { value: 'PR', name: 'Paraná' },
    { value: 'PE', name: 'Pernambuco' },
    { value: 'PI', name: 'Piauí' },
    { value: 'RJ', name: 'Rio de Janeiro' },
    { value: 'RN', name: 'Rio Grande do Norte' },
    { value: 'RS', name: 'Rio Grande do Sul' },
    { value: 'RO', name: 'Rondônia' },
    { value: 'RR', name: 'Roraima' },
    { value: 'SC', name: 'Santa Catarina' },
    { value: 'SP', name: 'São Paulo' },
    { value: 'SE', name: 'Sergipe' },
    { value: 'TO', name: 'Tocantins' },
  ];

  specialties: any;
  occupationAreas: any;

  professionalForm: FormGroup = new FormGroup({
    fullname: new FormControl(''),
    email: new FormControl(''),
    genre: new FormControl(''),
    civilStatus: new FormControl(''),
    document: new FormControl(''),
    identity: new FormControl(''),
    identityAgency: new FormControl(''),
    identityDate: new FormControl(''),
    identityUf: new FormControl(''),
    nationality: new FormControl(''),
    citizenship: new FormControl(''),
    birthplace: new FormControl(''),
    licenseNumber: new FormControl(''),
    rqe: new FormControl(''),
    majorMedicalSpecialty: new FormControl(''),
    otherSpecialties: new FormControl(''),
    occupationArea: new FormControl(''),
    cellphone: new FormControl(''),
    phone: new FormControl(''),
    birthdate: new FormControl(''),
    fatherName: new FormControl(''),
    motherName: new FormControl(''),
    voterRegistration: new FormControl(''),
    pis: new FormControl(''),
    type: new FormControl(''),
    numberHealth: new FormControl(''),
    bloodType: new FormControl(''),
    employmentType: new FormControl('service_provider'),
    isActive: new FormControl(true),
    status: new FormControl(''),
  });

  addressForm: FormGroup = new FormGroup({
    street: new FormControl(''),
    number: new FormControl(''),
    neighborhood: new FormControl(''),
    complement: new FormControl(''),
    city: new FormControl(''),
    zipcode: new FormControl(''),
    state: new FormControl(''),
  });

  bankForm: FormGroup = new FormGroup({
    bank: new FormControl(''),
    agency: new FormControl(''),
    account: new FormControl(''),
    typeAccount: new FormControl(''),
    accountType: new FormControl(''),
    keyPix: new FormControl(''),
  });

  filesForm: FormGroup = new FormGroup({
    requestLetter: new FormControl(''),
    idSizePhoto: new FormControl(''),
    curriculum: new FormControl(''),
    proofAddress: new FormControl(''),
    vaccineCard: new FormControl(''),
    crmCard: new FormControl(''),
    annuityDischarge: new FormControl(''),
    ethicsCertificate: new FormControl(''),
    qplsOrAclsCertificate: new FormControl(''),
    graduationCertificate: new FormControl(''),
    ethicalBackgroundStatement: new FormControl(''),
    medicineCertificate: new FormControl(''),
    medicalResidencyCertificate: new FormControl(''),
  });

  progressFilesUpload: any = {
    requestLetter: 0,
    idSizePhoto: 0,
    curriculum: 0,
    proofAddress: 0,
    vaccineCard: 0,
    crmCard: 0,
    annuityDischarge: 0,
    ethicsCertificate: 0,
    aplsOrAclsCertificate: 0,
    graduationCertificate: 0,
    ethicalBackgroundStatement: 0,
    medicineCertificate: 0,
    medicalResidencyCertificate: 0,
  };

  professionalData: any;
  documents: any[];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private formBuilder: FormBuilder,
    private professionalService: ProfessionalService,
    private specialtiesService: SpecialtiesService,
    private occupationAreasService: OccupationAreasService,
    private addressService: AddressService,
    private bankService: BankService,
    private dialog: MatDialog,
    private fileService: FileService,
    private snackbar: MatSnackBar,
    private clipboard: Clipboard
  ) {}

  ngOnInit(): void {
    this.route.params.pipe(take(1)).subscribe((params: any) => {
      this.professionalId = params['id'];

      if (this.professionalId) {
        this.specialtiesService
          .getAll()
          .pipe(take(1))
          .subscribe((data) => (this.specialties = data));
        this.occupationAreasService
          .getAll()
          .pipe(take(1))
          .subscribe((data) => (this.occupationAreas = data));
        this.getProfessionalId();
      }
    });
  }

  hasErrorProfessional(controlName: string, errorName: string) {
    return this.professionalForm.controls[controlName].hasError(errorName);
  }

  get documentsTotal(): number {
    return this.documents?.length ?? 0;
  }

  get documentsApproved(): number {
    return this.documents?.filter((doc: any) => doc?.status === 'APPROVED').length ?? 0;
  }

  get professionalTypeLabel(): string {
    const type = this.professionalForm?.get('type')?.value || this.professionalData?.type;
    switch (type) {
      case 'DOCTOR':
        return 'Médico(a)';
      case 'NURSE':
        return 'Enfermeiro(a)';
      default:
        return 'Profissional';
    }
  }

  fileSearch = '';
  fileStatusFilter: 'ALL' | 'APPROVED' | 'REJECTED' | 'PENDING_UPLOAD' | 'PENDING' =
    'ALL';

  get filteredFiles(): any[] {
    const files = this.professionalData?.files ?? [];
    const term = (this.fileSearch || '').trim().toLowerCase();

    return files
      .filter((file: any) => {
        if (this.fileStatusFilter === 'ALL') return true;
        return file?.status === this.fileStatusFilter;
      })
      .filter((file: any) => {
        if (!term) return true;
        const hay = `${file?.name ?? ''} ${file?.description ?? ''} ${file?.fieldname ?? ''}`.toLowerCase();
        return hay.includes(term);
      });
  }

  fileIconFor(mimetype?: string): string {
    if (!mimetype) return 'ri-file-3-line';
    if (mimetype.includes('pdf')) return 'ri-file-pdf-2-line';
    if (mimetype.startsWith('image/')) return 'ri-image-2-line';
    if (mimetype.includes('word')) return 'ri-file-word-2-line';
    if (mimetype.includes('excel') || mimetype.includes('spreadsheet'))
      return 'ri-file-excel-2-line';
    return 'ri-file-3-line';
  }

  hasErrorAddress(controlName: string, errorName: string) {
    return this.addressForm.controls[controlName].hasError(errorName);
  }

  hasErrorBank(controlName: string, errorName: string) {
    return this.bankForm.controls[controlName].hasError(errorName);
  }

  formatAccountNumber(event: any) {
    let value = event.target.value;
    const formattedValue = this.applyAccountMask(value);

    // Atualiza o valor no FormControl
    this.bankForm.patchValue({
      account: formattedValue
    });
  }

  private applyAccountMask(value: string): string {
    if (!value) return '';

    value = value.replace(/\D/g, '');

    if (value.length >= 2) {
      return value.slice(0, -1) + '-' + value.slice(-1);
    }

    return value;
  }

  goBack() {
    this.location.back();
  }

  copyToClipboard(value: any, fieldName: string) {
    if (!value) {
      this.snackbar.open('Nenhum valor para copiar', 'Fechar', {
        duration: 2000,
      });
      return;
    }
    
    const textToCopy = typeof value === 'object' ? JSON.stringify(value) : String(value);
    this.clipboard.copy(textToCopy);
    this.snackbar.open(`${fieldName} copiado para área de transferência`, 'Fechar', {
      duration: 2000,
    });
  }

  getNameStatus(status: string) {
    switch(status) {
      case 'APPROVED':
        return 'Aprovado';
      case 'REJECTED':
        return 'Rejeitado';
      case 'PENDING_UPLOAD':
        return 'Aguardando envio';
      case 'PENDING':
      default:
        return 'Pendente de análise';
    }
  }

  private getProfessionalId() {
    this.professionalService
      .getById(this.professionalId)
      .pipe(take(1))
      .subscribe((data: any) => {
        this.professionalData = data;
        this.documents = data.files;
        this.populateProfessional(data);
        this.populateAddresses(data.address);
        this.populateBank(data.bank);
      });
  }

  private populateProfessional(data: any) {
    const majorMedicalSpecialtyId = data?.majorMedicalSpecialty?.[0]?._id ?? '';
    const otherSpecialtiesId = data?.otherSpecialties?.[0]?._id ?? '';
    const occupationAreaId = data?.occupationArea?.[0]?._id ?? '';

    this.professionalForm = this.formBuilder.group({
      fullname: [
        data.fullname,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(255),
        ],
      ],
      email: [
        data.email,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(80),
        ],
      ],
      fatherName: [
        data.fatherName,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(80),
        ],
      ],
      motherName: [
        data.motherName,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(80),
        ],
      ],
      voterRegistration: [data.voterRegistration, [Validators.required]],
      birthdate: [data.birthdate, [Validators.required]],
      pis: [data.pis, [Validators.required]],
      genre: [data.genre, [Validators.required]],
      civilStatus: [data.civilStatus, [Validators.required]],
      document: [data.document, [Validators.required]],
      identity: [data.identity, [Validators.required]],
      identityAgency: [data.identityAgency, [Validators.required]],
      identityDate: [data.identityDate, [Validators.required]],
      identityUf: [data.identityUf, [Validators.required]],
      nationality: [data.nationality, [Validators.required]],
      citizenship: [data.citizenship, [Validators.required]],
      birthplace: [data.birthplace, [Validators.required]],
      licenseNumber: [data.licenseNumber, [Validators.required]],
      rqe: [data.rqe, [Validators.required]],
      majorMedicalSpecialty: [majorMedicalSpecialtyId, [Validators.required]],
      otherSpecialties: [otherSpecialtiesId, [Validators.required]],
      occupationArea: [occupationAreaId, [Validators.required]],
      cellphone: [data.cellphone, [Validators.required]],
      phone: [data.phone],
      type: [data.type, [Validators.required]],
      numberHealth: [data.numberHealth],
      bloodType: [data.bloodType],
      employmentType: [data.employmentType || 'service_provider'],
      isActive: [data.isActive !== false],
      status: [data.status || ''],
    });
  }

  private populateAddresses(data: any) {
    if (!data) {
      this.addressForm = this.formBuilder.group({
        id: ['', Validators.required],
        street: ['', [Validators.required]],
        number: ['', [Validators.required]],
        neighborhood: ['', [Validators.required]],
        complement: [''],
        city: ['', [Validators.required]],
        zipcode: ['', [Validators.required, Validators.minLength(8)]],
        state: ['', [Validators.required]],
      });
      return;
    }
    this.addressForm = this.formBuilder.group({
      id: [data._id, Validators.required],
      street: [data.street, [Validators.required]],
      number: [data.number, [Validators.required]],
      neighborhood: [data.neighborhood, [Validators.required]],
      complement: [data.complement],
      city: [data.city, [Validators.required]],
      zipcode: [data.zipcode, [Validators.required, Validators.minLength(8)]],
      state: [data.state, [Validators.required]],
    });
  }

  private populateBank(data: any) {
    if (!data) {
      this.bankForm = this.formBuilder.group({
        id: ['', Validators.required],
        bank: ['', [Validators.required]],
        agency: ['', [Validators.required]],
        account: ['', [Validators.required]],
        typeAccount: ['', [Validators.required]],
        accountType: ['', [Validators.required]],
        keyPix: ['', [Validators.required]],
      });
      return;
    }
    this.bankForm = this.formBuilder.group({
      id: [data._id, Validators.required],
      bank: [data.bank, [Validators.required]],
      agency: [data.agency, [Validators.required]],
      account: [this.applyAccountMask(data.account), [Validators.required]],
      typeAccount: [data.typeAccount, [Validators.required]],
      accountType: [data.accountType || '', [Validators.required]],
      keyPix: [data.keyPix, [Validators.required]],
    });
  }

  private getModifiedFormValues(): any {
    const modifiedValues: any = {};
    Object.keys(this.professionalForm.controls).forEach(key => {
      const control = this.professionalForm.get(key);
      if (control && control.dirty) {
        modifiedValues[key] = control.value;
      }
    });
    return modifiedValues;
  }

  onProfessionalSubmit() {
    const phone = (this.professionalForm.value.phone || '').replace(/\D+/g, '');
    const cellphone = (this.professionalForm.value.cellphone || '').replace(/\D+/g, '');

    const formData = {
      ...this.professionalForm.value,
      phone,
      cellphone,
    };

    // Handle isActive separately via dedicated endpoint
    const newIsActive: boolean = formData.isActive;
    delete formData.isActive;

    const originalIsActive = this.professionalData?.isActive !== false;
    if (newIsActive !== originalIsActive) {
      this.professionalService.toggleActive(this.professionalId, newIsActive).subscribe();
    }

    // Handle status separately via dedicated endpoint
    const newStatus: string = formData.status;
    delete formData.status;

    const originalStatus = this.professionalData?.status;
    if (newStatus && newStatus !== originalStatus) {
      this.professionalService.status(this.professionalId, newStatus).subscribe();
    }

    this.professionalService
      .updateById(this.professionalId, formData)
      .subscribe(
        () =>
          this.snackbar.open('Atualizado com sucesso', 'OK', {
            duration: 3000,
          }),
        () =>
          this.snackbar.open('Não foi possível atualizar informações', 'OK', {
            duration: 3000,
          })
      );
  }

  onAddressSubmit() {
    this.addressService
      .updateById(this.addressForm.value.id, this.addressForm.value)
      .subscribe(
        () =>
          this.snackbar.open('Atualizado com sucesso', 'OK', {
            duration: 3000,
          }),
        () =>
          this.snackbar.open('Não foi possível atualizar informações', 'OK', {
            duration: 3000,
          })
      );
  }

  onBankSubmit() {
    const bankData = { ...this.bankForm.value };
    // Remove a máscara do número da conta antes de enviar
    bankData.account = bankData.account.replace(/\D/g, '');

    this.bankService
      .updateById(bankData.id, bankData)
      .subscribe(
        () =>
          this.snackbar.open('Atualizado com sucesso', 'OK', { duration: 300 }),
        () =>
          this.snackbar.open('Não foi possível atualizar informações', 'OK', {
            duration: 3000,
          })
      );
  }

  convertSize(bytes: number, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }

    const units = si
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (
      Math.round(Math.abs(bytes) * r) / r >= thresh &&
      u < units.length - 1
    );

    return bytes.toFixed(dp) + ' ' + units[u];
  }

  openDialog(fileId: string, field: string, description: string, title: string): void {
    const dialogRef = this.dialog.open(ModalFileComponent, {
      data: { fileId, field, description, title, professionalId: this.professionalId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getProfessionalId();
    });
  }

  viewFileDialog(fileId: string, mimetype: string): void {
    const maxWidth = window.innerWidth * 0.8;
    const maxHeight = window.innerHeight * 0.85;

    const dialogRef = this.dialog.open(ModalPdfViewerComponent, {
      data: { fileId, mimetype, professionalId: this.professionalId },
      maxWidth: `${maxWidth}px`,
      maxHeight: `${maxHeight}px`,
      height: 'auto',
      width: 'auto',
      panelClass: 'document-viewer-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }

  downloadFile(fileId: string, mimetype: string, filename: string) {
    this.fileService.download(fileId, mimetype, `${this.professionalData.fullname}-${filename}`).subscribe(
      () => this.snackbar.open('Concluido', 'OK', { duration: 300 }),
      () =>
        this.snackbar.open('Nao foi possivel baixar o arquivo', 'OK', {
          duration: 3000,
        })
    );
  }

  checkFile(fileId: string, status: string) {
    // Se o status for REJECTED, abrir modal para capturar o motivo
    if (status === 'REJECTED') {
      this.openRejectDocumentModal(fileId);
      return;
    }

    // Para outros status (APPROVED, PENDING, etc), executar diretamente
    this.fileService.check(status, fileId).subscribe(
      () => {
        this.snackbar.open('Atualizado com sucesso', 'OK', { duration: 6000 });
        this.professionalData.files = this.professionalData.files.map((file: any) => {
          if (file._id === fileId) {
            return { ...file, status };
          }

          return file;
        });
      },
      () =>
        this.snackbar.open(
          'Nao foi possivel validar o arquivo, tente novamente mais tarde!',
          'OK',
          {
            duration: 3000,
          }
        )
    );
  }

  openRejectDocumentModal(fileId: string) {
    const document = this.professionalData.files.find((file: any) => file._id === fileId);
    
    if (!document) {
      return;
    }

    const dialogRef = this.dialog.open(RejectDocumentModalComponent, {
      width: '600px',
      maxWidth: '90vw',
      data: {
        fileId: fileId,
        fileName: document.description || document.name,
        professionalName: this.professionalData.fullname
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((wasRejected: boolean) => {
      if (wasRejected) {
        this.professionalData.files = this.professionalData.files.map((file: any) => {
          if (file._id === fileId) {
            return { ...file, status: 'REJECTED' };
          }
          return file;
        });
        
        if (this.documents) {
          this.documents = this.documents.map((doc: any) => {
            if (doc._id === fileId) {
              return { ...doc, status: 'REJECTED' };
            }
            return doc;
          });
        }
      }
    });
  }

  hasApprovedDocuments(): boolean {
    if (!this.documents || this.documents.length === 0) {
      return false;
    }
    return this.documents.some(doc => doc.status === 'APPROVED');
  }

  downloadAllApprovedDocuments() {
    const approvedDocs = this.documents.filter(doc => doc.status === 'APPROVED');

    if (approvedDocs.length === 0) {
      this.snackbar.open('Não há documentos aprovados para download', 'Fechar', {
        duration: 3000
      });
      return;
    }

    approvedDocs.forEach(doc => {
      this.fileService.download(
        doc._id,
        doc.mimetype,
        `${this.professionalData.fullname}-${doc.name}`
      ).subscribe(
        () => console.log(`Documento ${doc.name} baixado com sucesso`),
        (error) => this.snackbar.open(`Erro ao baixar ${doc.name}`, 'OK', {
          duration: 3000
        })
      );
    });

    this.snackbar.open('Iniciando download dos documentos aprovados', 'OK', {
      duration: 3000
    });
  }
}
